import { generateOpdrachtSource } from '../utils/lodashUtils'

export const ContactPersonJobTitleSource = [
  { value: 'TEACHER', label: 'Teacher' },
  { value: 'DIRECTOR_OR_ADJUNCT_DIRECTOR', label: 'Director or adjunct director' },
  { value: 'GENERAL_ITC_COORDINATOR', label: 'General ITC coordinator' },
  { value: 'TECHNICAL_ITC_COORDINATOR', label: 'Technical ITC coordinator' },
  { value: 'PEDAGOGICAL_ITC_COORDINATOR', label: 'Pedagogical ITC coordinator' },
  { value: 'STUDENT_COUNSELOR', label: 'Student counselor' },
  { value: 'TEACHER_COUNSELOR', label: 'Teacher counselor' },
  { value: 'DEGREE_COORDINATOR', label: 'Degree coordinator' },
  { value: 'TECHNICAL_ADVISOR_COORDINATOR', label: 'Technical advisor coordinator' },
  { value: 'OTHER', label: 'Other' },
]

export const DirectorPersonJobTitleSource = [
  { value: 'COORDINATING_DIRECTOR', label: 'Coordinating director' },
  { value: 'DIRECTOR', label: 'Director' },
  { value: 'PEDAGOGICAL_DIRECTOR', label: 'Pedagogical director' },
]

export const NumberOfStaffMembersSource = [
  { value: 'MINDER_DAN_20', label: 'Less than 20' },
  { value: 'TUSSEN_20_EN_40', label: 'Between 20 and 40' },
  { value: 'TUSSEN_41_EN_70', label: 'Between 40 and 70' },
  { value: 'TUSSEN_71_EN_110', label: 'Between 71 and 110' },
  { value: 'TUSSEN_111_EN_160', label: 'Between 111 and 160' },
  { value: 'MEER_DAN_160', label: 'More than 160' },
]

export const NumberOfStudentsSource = [
  { value: 'MINDER_DAN_60', label: 'Less than 60' },
  { value: 'TUSSEN_61_EN_130', label: 'Between 61 and 130' },
  { value: 'TUSSEN_131_EN_200', label: 'Between 131 and 200' },
  { value: 'TUSSEN_201_EN_300', label: 'Between 201 and 300' },
  { value: 'TUSSEN_301_EN_450', label: 'Between 301 and 450' },
  { value: 'TUSSEN_451_EN_700', label: 'Between 451 and 700' },
  { value: 'TUSSEN_701_EN_1500', label: 'Between 701 and 1500' },
  { value: 'MEER_DAN_1500', label: 'More than 1500' },
]

export const ProvinceSource = [
  { value: 'ANTWERPEN', label: 'Antwerpen' },
  { value: 'BRUSSEL_19_GEMEENTEN', label: 'Brussel (19 gemeenten)' },
  { value: 'VLAAMS_BRABANT', label: 'Vlaams-Brabant' },
  { value: 'LIMBURG', label: 'Limburg' },
  { value: 'OOST_VLAANDEREN', label: 'Oost-Vlaanderen' },
  { value: 'WEST_VLAANDEREN', label: 'West-Vlaanderen' },
  { value: 'BUITEN_VLAANDEREN', label: 'Buiten-Vlaanderen' },
]

export const ProvinceSourceObjectValueLabels = ProvinceSource.reduce((acc, curr) => {
  acc[curr.value] = curr.label
  return acc
}, {})

export const EducationNetworkSource = [
  { value: 'KATHOLIEK_ONDERWIJS_VLAANDEREN', label: 'Catholic Education Flanders' },
  { value: 'GO_ONDERWIJS', label: 'GO! Education' },
  {
    value: 'ONDERWIJSKOEPEL_STEDEN_EN_GEMEENTEN',
    label: 'Educational umbrella for Cities and Municipalities',
  },
  { value: 'PROVINCIAAL_ONDERWIJS_VLAANDEREN', label: 'Provincial Education Flanders' },
  { value: 'ANDER', label: 'Other' },
]

export const EducationLevelSource = [
  { value: 'BASISONDERWIJS', label: 'Primary education' },
  { value: 'BUITENGEWOON_BASISONDERWIJS', label: 'Special needs primary education' },
  { value: 'SECUNDAIR_ONDERWIJS', label: 'Secondary education' },
  { value: 'BUITENGEWOON_SECUNDAIR_ONDERWIJS', label: 'Special needs secondary education' },
  { value: 'DEELTIJDS_KUNSTONDERWIJS', label: 'Part-time art education' },
  { value: 'DEELTIJDS_BEROEPSONDERWIJS', label: 'Part-time vocational education' },
  { value: 'HOGER_BEROEPSONDERWIJS', label: 'Vocational education' },
  { value: 'VOLWASSENENONDERWIJS', label: 'Adult education' },
  { value: 'HOGESCHOOL', label: 'College' },
  { value: 'UNIVERSITEIT', label: 'University' },
]

export const AnswerTypeSourceValueRadio = 'RADIO'
export const AnswerTypeSourceValueSelect = 'SELECT'
export const AnswerTypeSourceValueTextField = 'TEXT_FIELD'

export const AnswerTypeSource = [
  { value: AnswerTypeSourceValueRadio, label: 'Radio' },
  { value: AnswerTypeSourceValueSelect, label: 'Select' },
  { value: AnswerTypeSourceValueTextField, label: 'Text field' },
]

export const AnswerSelectTypeSourceValueJobTitle = 'JOB_TITLE'
export const AnswerSelectTypeSourceValueYearsOfExperience = 'YEARS_OF_EXPERIENCE'
export const AnswerSelectTypeSourceValueSeniority = 'SENIORITY'
export const AnswerSelectTypeSourceValueSex = 'SEX'
export const AnswerSelectTypeSourceValueAge = 'AGE'

export const AnswerSelectTypeSource = [
  { value: AnswerSelectTypeSourceValueJobTitle, label: 'Job title' },
  { value: AnswerSelectTypeSourceValueYearsOfExperience, label: 'Years of experience' },
  { value: AnswerSelectTypeSourceValueSeniority, label: 'Seniority' },
  { value: AnswerSelectTypeSourceValueSex, label: 'Sex' },
  { value: AnswerSelectTypeSourceValueAge, label: 'Age' },
]

export const QuestionCategorySource = [
  { value: 'DIGITAL_KNOW_HOW', label: 'Digital know how' },
  { value: 'VISION', label: 'Vision' },
  { value: 'LEADING_DIGITALISATION', label: 'Leading digitalisation' },
  { value: 'SCHOOL_CULTURE', label: 'School culture' },
  { value: 'SCHOOL_ORGANISATION', label: 'School organisation' },
  { value: 'ITC_INFRASTRUCTURE', label: 'ITC infrastructure' },
  { value: 'ANDER', label: 'Other' },
]

export const SurveyParticipantSource = [
  { value: 'LERAAR', label: 'Teacher' },
  { value: 'DIRECTIE', label: 'Director' },
  { value: 'COORDINATOR_ICT', label: 'ITC coordinator' },
  { value: 'ALGEMENE_VERWOORDING', label: 'General wording' },
  { value: 'LEERLING', label: 'Student' },
]

export const SchoolleaderSurveyParticipantSource = [
  { values: 'LEERKRACHT_OF_ANDERE_MEDEWERKER', label: 'leerkracht of andere medewerker' },
  { values: 'ADJUNCT_OF_COORDINATOR', label: 'adjunct of coördinator' },
  { values: 'LEIDINGGEVENDE_OF_BESTUURDER', label: 'leidinggevende of bestuurder' },
  { values: 'ZELF', label: 'zelf' },
]

export const SchoolleaderSurveyParticipantSourceObject = {
  LEERKRACHT_OF_ANDERE_MEDEWERKER: 'leerkracht of andere medewerker',
  ADJUNCT_OF_COORDINATOR: 'adjunct of coördinator',
  LEIDINGGEVENDE_OF_BESTUURDER: 'leidinggevende of bestuurder',
  ZELF: 'zelf',
}

export const PositionSource = [
  { value: 0, label: 1 },
  { value: 1, label: 2 },
  { value: 2, label: 3 },
  { value: 3, label: 4 },
  { value: 4, label: 5 },
  { value: 5, label: 6 },
  { value: 6, label: 7 },
  { value: 7, label: 8 },
  { value: 8, label: 9 },
  { value: 9, label: 10 },
]

export const YearsOfExperienceSource = [
  { value: 'MINDER_DAN_1_JAAR', label: 'Less than 1 year' },
  { value: 'TUSSEN_1_EN_3_JAAR', label: 'Between 1 and 3 years' },
  { value: 'TUSSEN_4_EN_7_JAAR', label: 'Between 4 and 7 years' },
  { value: 'TUSSEN_8_EN_12_JAAR', label: 'Between 8 and 12 years' },
  { value: 'TUSSEN_13_EN_18_JAAR', label: 'Between 13 and 18 years' },
  { value: 'TUSSEN_19_EN_25_JAAR', label: 'Between 19 and 25 years' },
  { value: 'MEER_DAN_25_JAAR', label: 'More than 25 years' },
]

export const SenioritySource = [
  { value: 'MINDER_DAN_1_JAAR', label: 'Less than 1 year' },
  { value: 'TUSSEN_1_EN_3_JAAR', label: 'Between 1 and 3 years' },
  { value: 'TUSSEN_4_EN_7_JAAR', label: 'Between 4 and 7 years' },
  { value: 'TUSSEN_8_EN_12_JAAR', label: 'Between 8 and 12 years' },
  { value: 'TUSSEN_13_EN_18_JAAR', label: 'Between 13 and 18 years' },
  { value: 'TUSSEN_19_EN_25_JAAR', label: 'Between 19 and 25 years' },
  { value: 'MEER_DAN_25_JAAR', label: 'More than 25 years' },
]

export const GenderSource = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  { value: 'OTHER', label: 'Other' },
]

export const JobTitleSource = [
  { value: 'LERAAR_1', label: 'Leraar' },
  { value: 'DIRECTIE', label: 'Directeur of adjunct-directeur' },
  { value: 'COORDINATOR_ICT_1', label: 'Algemeen ICT-coördinator' },
  { value: 'COORDINATOR_ICT_2', label: 'Technisch ICT-coördinator' },
  { value: 'COORDINATOR_ICT_3', label: 'Pedagogisch ICT-coördinator' },
  { value: 'LERAAR_2', label: 'Leerlingenbegeleider' },
  { value: 'LERAAR_3', label: 'Lerarenbegeleider' },
  { value: 'LERAAR_4', label: 'Graadcoördinator' },
  { value: 'LERAAR_5', label: 'Technisch adviseur coördinator' },
  { value: 'LERAAR_6', label: 'Ander' },
]

export const AgeCategorySource = [
  { value: 'JONGER_DAN_25_JAAR', label: 'Less than 25 years' },
  { value: 'TUSSEN_25_EN_30_JAAR', label: 'Between 25 and 30 years' },
  { value: 'TUSSEN_31_EN_35_JAAR', label: 'Between 31 and 35 years' },
  { value: 'TUSSEN_36_EN_45_JAAR', label: 'Between 36 and 45 years' },
  { value: 'TUSSEN_46_EN_55_JAAR', label: 'Between 46 and 55 years' },
  { value: 'TUSSEN_56_EN_65_JAAR', label: 'Between 56 and 65 years' },
  { value: 'OUDER_DAN_65_JAAR', label: 'More than 65 years' },
]

export const AnswerSelectSourcePairs = {
  [AnswerSelectTypeSourceValueJobTitle]: JobTitleSource,
  [AnswerSelectTypeSourceValueYearsOfExperience]: YearsOfExperienceSource,
  [AnswerSelectTypeSourceValueSeniority]: SenioritySource,
  [AnswerSelectTypeSourceValueSex]: GenderSource,
  [AnswerSelectTypeSourceValueAge]: AgeCategorySource,
}

export const VisualisationTypeSource = [
  { value: 'HORIZONTAL_GROUPED', label: 'HORIZONTAL_GROUPED' },
  { value: 'HORIZONTAL_SINGLE_COUNTS', label: 'HORIZONTAL_SINGLE_COUNTS' },
  { value: 'HORIZONTAL_SINGLE_PERCENTAGE', label: 'HORIZONTAL_SINGLE_PERCENTAGE' },
]

export const EducationLevelSourceNL = [
  { value: 'BASISONDERWIJS', label: 'Basisonderwijs' },
  { value: 'BUITENGEWOON_BASISONDERWIJS', label: 'Buitengewoon basisonderwijs' },
  { value: 'SECUNDAIR_ONDERWIJS', label: 'Secundair onderwijs' },
  { value: 'BUITENGEWOON_SECUNDAIR_ONDERWIJS', label: 'Buitengewoon secundair onderwijs' },
  { value: 'DEELTIJDS_KUNSTONDERWIJS', label: 'Deeltijds kunstonderwijs' },
  { value: 'DEELTIJDS_BEROEPSONDERWIJS', label: 'Deeltijds beroepsonderwijs' },
  { value: 'HOGER_BEROEPSONDERWIJS', label: 'Hoger beroepsonderwijs' },
  { value: 'VOLWASSENENONDERWIJS', label: 'Volwassenenonderwijs' },
  { value: 'HOGESCHOOL', label: 'Hogeschool' },
  { value: 'UNIVERSITEIT', label: 'Universiteit' },
]

export const EnergyLevelSource = [
  { value: 'IN_ZEER_GERINGE_MATE', label: 'in zeer geringe mate' },
  { value: 'IN_EERDER_GERINGE_MATE', label: 'in eerder geringe mate' },
  { value: 'NIET_IN_GERINGE_NIET_IN_HOGE_MATE', label: 'niet in geringe, niet in hoge mate' },
  { value: 'IN_EERDER_HOGE_MATE', label: 'in eerder hoge mate' },
  { value: 'IN_ZEER_HOGE_MATE', label: 'in zeer hoge mate' },
]

export const ThinkingOfStoppingSource = [
  { value: 'QUASI_ELKE_DAG', label: 'quasi elke dag' },
  { value: 'VAAK', label: 'vaak' },
  { value: 'GEREGELD', label: 'geregeld' },
  { value: 'ZELDEN', label: 'zelden' },
  { value: 'NOOIT', label: 'nooit' },
]

export const AddressingFormulaSource = [
  { value: 'ANDERE', label: 'andere' },
  { value: 'HEER', label: 'heer' },
  { value: 'MEVROUW', label: 'mevrouw' },
]

export const SchoolLeaderJobTitleSource = [
  { value: 'BEHEERDER', label: 'beheerder' },
  { value: 'ALGEMEEN_DIRECTEUR', label: 'algemeen directeur' },
  { value: 'DIRECTEUR', label: 'directeur' },
  { value: 'ADJUNCT_DIRECTEUR', label: 'adjunct-directeur' },
  { value: 'GRAADCOORDINATOR', label: 'graadcoördinator' },
  { value: 'TECHNISCH_ADVISEUR_COORDINATOR', label: 'technisch adviseur-coördinator' },
  { value: 'ZORGCOORDINATOR', label: 'zorgcoördinator' },
  { value: 'ICT_COORDINATOR', label: 'ICT-coördinator' },
  { value: 'VAKGROEPVERANTWOORDELIJKE', label: 'vakgroepverantwoordelijke' },
  { value: 'TECHNISCH_ADVISEUR', label: 'technisch adviseur' },
  { value: 'ANDERE', label: 'andere' },
]
export const SpreidingOpdrachtSource = generateOpdrachtSource(20, 'SO')
export const BelangOpdrachtSource = generateOpdrachtSource(20, 'BO')

export const WorkRelationWithSchoolleaderSource = [
  {
    value: 'LEERKRACHT_OF_ANDERE_MEDEWERKER',
    label: 'ik ben een leerkracht of andere medewerker van de schoolleider',
  },
  {
    value: 'ADJUNCT_OF_COORDINATOR',
    label: 'ik ben een adjunct of een coördinator van de schoolleider',
  },
  {
    value: 'LEIDINGGEVENDE_OF_BESTUURDER',
    label: 'ik ben leidinggevende of bestuurder van de schoolleider',
  },
  { value: 'ZELF', label: 'ik ben de schoolleider zelf' },
]

export const SurveyDurationSource = [
  { value: 'LESS_THEN_10_MINUTES', label: '< 10 minuten' },
  { value: 'BETWEEN_10_15_MINUTES', label: '10 à 15 minuten' },
  { value: 'BETWEEN_15_20_MINUTES', label: '15 à 20 minuten' },
  { value: 'BETWEEN_20_25_MINUTES', label: '20 à 25 minuten' },
  { value: 'BETWEEN_25_30_MINUTES', label: '25 à 30 minuten' },
  { value: 'BETWEEN_30_40_MINUTES', label: '30 à 40 minuten' },
  { value: 'MORE_THEN_40_MINUTES', label: '> 40 minuten' },
]

export const YesNoSelectSource = [
  {
    value: true,
    label: 'Yes',
  },
  { value: false, label: 'No' },
]
